import React, { useEffect } from "react";
import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./Home";
import MFregiApp from "./components/MFregister/MFregiApp";
import MFuserApp from "./components/MFuser/MFuserApp";
import RegiFormTest from "./components/MFregister/regiformtest";
import RdvAttendPage from "./pages/RdvAttendPage";
import RdvAttendScannerPage from "./pages/RdvAttendScannerPage";
import StandaloneChatPage from "./pages/StandaloneChatPage";
import QrPhoneInputPage from "./pages/QrPhoneInputPage";
import QrDisplayPage from "./pages/QrDisplayPage";
import { ChatSocketProvider } from "./contexts/ChatSocketContext";

///////////////////////// API 주소: 로컬 개발 시에도 원격 백엔드만 사용 /////////////////////////
const apiAddr =
  process.env.REACT_APP_API_ADDR || "https://qry.119survey.org";
///////////////////////// API 주소 /////////////////////////

/** 이미 발송된 /qra 링크 → 기존 경로로 리다이렉트 (운영 서버 SPA fallback) */
function QraLegacyRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/qrattendmgr${search}`} replace />;
}

function App(props) {
  // 탭 닫기, 새로고침, 다른 사이트로 이동 시 브라우저 기본 경고 (인수인계 완료 후 리다이렉트는 제외)
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (sessionStorage.getItem("skipBeforeUnload") === "1") return;
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  return (
    <div>
      {/* <nav>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/regi">regi</Link>
          </li>
          <li>
            <Link to="/user">user</Link>
          </li>
        </ul>
      </nav> */}
      <Routes>
        <Route path="/" element={<Home apiAddr={apiAddr} />} />
        <Route path="/cn" element={<Home apiAddr={apiAddr} />} />
        <Route path="/jn" element={<Home apiAddr={apiAddr} />} />
        <Route path="/regi" element={<MFregiApp apiAddr={apiAddr} />} />
        <Route path="/user" element={<ChatSocketProvider><MFuserApp apiAddr={apiAddr} /></ChatSocketProvider>} />
        <Route path="/regi-test" element={<RegiFormTest />} />
        <Route path="/qrattendmgr" element={<RdvAttendPage apiAddr={apiAddr} />} />
        <Route path="/qra" element={<QraLegacyRedirect />} />
        <Route path="/qrattend-scanner" element={<RdvAttendScannerPage apiAddr={apiAddr} />} />
        <Route path="/standalone-chat" element={<StandaloneChatPage apiAddr={apiAddr} />} />
        <Route path="/qr-phone" element={<QrPhoneInputPage />} />
        <Route path="/qr-display" element={<QrDisplayPage />} />
      </Routes>
    </div>
  );
}

export default App;
